function customTime(time) {
  return time?.split("T")?.[1]?.substring(0, 5);
}

export default customTime;
